import React from 'react';
import BrandLogo from '../components/BrandLogo';
import RegistrationForm from '../components/RegistrationForm';
import '../styles/AuthPage.css';

const RegistrationPage = () => (
    <div className="sc-auth-page">
        <div className="sc-auth-card sc-auth-card--wide">
            <header className="auth-header">
                <BrandLogo className="sc-auth-logo" />
                <div className="auth-header-text">
                    <h1>Create an account</h1>
                    <p>Pick a username, a password, and an avatar</p>
                </div>
            </header>
            <div className="auth-body">
                <RegistrationForm />
            </div>
        </div>
    </div>
);

export default RegistrationPage;
